import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { savedCNYData } from "../../../redux/formDataSlice";

import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";

import { CNYProps, FormInputs } from "../../../../../types/walletTypes";
import { formRegistry } from "../formRegistry";

const PaymentDetails = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const { orderDate, ...defaultValues } = getSavedData || {};

  const {
    handleSubmit,
    control,

    formState: { errors },
  } = useForm<FormInputs>({ defaultValues });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  const currentStep = "payment";

  const CurrentStepComponent = formRegistry[currentStep]?.[
    getSavedData?.paymentMethod
  ] as any;

  if (!CurrentStepComponent) return null;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CurrentStepComponent
        control={control}
        errors={errors}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
      />
    </form>
  );
};

export default PaymentDetails;
